interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const MultiPageIcon = ({ width = 34, height = 27, color = '#000000' }: Properties) => {
  return (
    <svg
      fill={color}
      version='1.1'
      id='Layer_1'
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 100 100'
      enable-background='new 0 0 100 100'
    >
      <g>
        <g>
          <path
            d='M75.272,7.482h-0.005v-4.02c0-0.956-0.774-1.73-1.73-1.73h-2.45v0H42.397v0h-1.73l-25.95,25.95v2.447v1.013v52.912v2.447
			c0,0.956,0.774,1.73,1.73,1.73h1.582h53.925h1.582c0.956,0,1.73-0.774,1.73-1.73v-2.448h0.005L75.272,7.482z M24.674,78.276
			V31.142h17.723c0.956,0,1.73-0.774,1.73-1.73V11.689h21.188l0,66.587H24.674z'
          />
        </g>
        <path
          d='M83.77,24.857h-3.475v66.911c0,0.835-0.677,1.513-1.513,1.513H29.306v3.475c0,0.836,0.677,1.513,1.513,1.513l0.001,0v0
		h52.95c0.836,0,1.513-0.677,1.513-1.513V26.37C85.283,25.534,84.606,24.857,83.77,24.857z'
        />
      </g>
    </svg>
  );
};

export default MultiPageIcon;
